import { useCallback } from 'react';
import { InformationIcon } from 'tuui/lib/atoms/Icon/Icons';
import { FormField } from 'taboola-ultimate-ui';
import { ExternalLink } from 'components';
import { ToggleSwitchWithLabel } from 'components/ToggleSwitchWithLabel/ToggleSwitchWithLabel';
import { usePaceAheadEnabled } from 'modules/campaigns/modules/campaigns-group-form/hooks/usePaceAheadEnabled';
import { useFormFieldValue } from 'modules/taboola-common-frontend-modules/formData';
import { FormattedMessage, useIntl } from 'modules/taboola-common-frontend-modules/i18n';
import styles from './paceAhead.module.scss';

const PaceAhead = () => {
    const { formatMessage } = useIntl();
    const isPaceAheadEnabled = usePaceAheadEnabled();
    const { value: isPaceAheadActive, onChange: setIsPaceAheadActive } = useFormFieldValue({
        field: 'budget.isPaceAhead',
    });
    const handleToggle = useCallback(
        checked => {
            setIsPaceAheadActive(checked);
        },
        [setIsPaceAheadActive]
    );

    return (
        isPaceAheadEnabled && (
            <div className={styles['pace-ahead-container']}>
                <FormField
                    label={
                        <>
                            <FormattedMessage
                                id="campaign.editor.pace.ahead.title"
                                defaultMessage="Pace Ahead"
                                tagName="h4"
                            />
                            <ExternalLink
                                href={formatMessage({
                                    id: 'campaign.editor.pace.ahead.help.center.href',
                                })}
                                className={styles['link']}
                            >
                                <InformationIcon className={styles['info-icon']} />
                                <div>Help Center</div>
                            </ExternalLink>
                        </>
                    }
                    inputId="pace-ahead"
                    description={
                        <FormattedMessage
                            id="campaign.editor.pace.ahead.description"
                            defaultMessage="Instead of equal allocation, accelerate the budget by 20% at the start of the campaign for a strong launch. This may deplete funds early, add more budget to keep it running if needed."
                        />
                    }
                    containerClass={styles['field-container']}
                    labelClass={styles['label']}
                >
                    <ToggleSwitchWithLabel
                        checked={isPaceAheadActive === true}
                        onChange={handleToggle}
                        label={
                            isPaceAheadActive === true ? (
                                <FormattedMessage
                                    id="campaign.editor.pace.ahead.status.active"
                                    defaultMessage="Pace Ahead is Active"
                                />
                            ) : (
                                <FormattedMessage
                                    id="campaign.editor.pace.ahead.status.disable"
                                    defaultMessage="Pace Ahead is Disabled"
                                />
                            )
                        }
                    />
                </FormField>
            </div>
        )
    );
};

export default PaceAhead;
